import { getPromotionsAdminAPI } from "./api";

export function getPromotionsAdmin(data) {
  return new Promise((resolve, reject) => {
    getPromotionsAdminAPI(data)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}